<section class="composer" aria-label="Staff page composer">
  <ng-container *ngIf="pageSettingsState as pageSettings">
  <ng-container *ngIf="contentLibraryState as library">
  <div class="composer-toolbar" [hidden]="noticeSettingsOpen">
    <div class="mode-switch" role="group" aria-label="Page mode">
      <button
        uiButton
        [text]="true"
        [outlined]="false"
        type="button"
        [attr.aria-pressed]="mode === 'edit'"
        (click)="setMode('edit')"
      >
        Edit
      </button>
      <button
        uiButton
        [text]="true"
        [outlined]="false"
        type="button"
        [attr.aria-pressed]="mode === 'try'"
        (click)="setMode('try')"
      >
        Try page · isolated step
      </button>
    </div>
    <ng-container *ngIf="mode === 'edit'">
      <button uiButton type="button" data-page-settings [disabled]="loading" [attr.aria-pressed]="(selection?.kind === 'tabs' || selection?.kind === 'context') && inspectorOpen" (click)="openPageSettings(pageSettings.origin)">Page settings</button>
      <button
        uiButton
        severity="primary"
        [outlined]="false"
        type="button"
        (click)="
          workEditorAvailable
            ? openActions.emit()
            : configure({ kind: 'action-library' })
        "
        [disabled]="disabled || loading"
        [attr.aria-label]="
          workEditorAvailable
            ? 'Manage staff actions in Work'
            : 'Add staff action'
        "
      >
        <i class="pi pi-plus" aria-hidden="true"></i>
        {{ workEditorAvailable ? "Actions in Work" : "Add action" }}
      </button>
      <button
        uiButton
        #libraryButton
        type="button"
        aria-label="Add main content"
        [disabled]="disabled || loading"
        (click)="showLibrary('main', undefined, library.origin)"
        [attr.aria-expanded]="libraryOpen"
      >
        <i class="pi pi-plus" aria-hidden="true"></i> Add main content…
      </button>
      <button
        uiButton
        type="button"
        aria-label="Add reference content"
        [disabled]="disabled || loading || detail.contextPlacement === 'hidden'"
        [title]="
          detail.contextPlacement === 'hidden'
            ? 'Show reference content in Page settings before adding content.'
            : 'Add to the reference rail'
        "
        (click)="showLibrary('supporting', undefined, library.origin)"
      >
        <i class="pi pi-plus" aria-hidden="true"></i> Add reference content…
      </button>
      <button
        uiButton
        type="button"
        aria-label="Undo staff page change"
        [disabled]="!canUndo"
        [title]="
          canUndo ? 'Undo: ' + undoLabel : 'No staff page changes to undo'
        "
        (click)="undo()"
      >
        <i class="pi pi-undo" aria-hidden="true"></i> Undo
      </button>
    </ng-container>
    <button
      uiButton
      severity="danger"
      *ngIf="issues.length"
      type="button"
      class="issue-count"
      [attr.aria-expanded]="issuesOpen"
      (click)="issuesOpen = !issuesOpen"
    >
      <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
      {{ issues.length }} {{ issues.length === 1 ? "issue" : "issues" }}
    </button>
    <div class="canvas-tools">
      <label class="canvas-size"
        ><span>Width</span>
        <select
          uiControl
          #staffCanvasPicker
          aria-label="Staff page preview width"
          [ngModel]="canvasSize"
          (ngModelChange)="setCanvasSizeFromControl($event, staffCanvasPicker)"
        >
          <option value="available">Available width</option>
          <option value="phone">Phone · 390px</option>
        </select>
      </label>
      <small class="canvas-scale"
        >{{ canvasWidth ? canvasWidth + "px · " : "" }}100%</small
      >
      <button
        uiButton
        *ngIf="mode === 'edit'"
        type="button"
        class="inspector-toggle"
        [attr.aria-expanded]="inspectorOpen"
        (click)="setInspector(!inspectorOpen)"
      >
        {{ inspectorOpen ? "Hide settings" : "Show settings" }}
      </button>
    </div>
    <small class="sample-label">{{
      mode === "try" ? "Isolated step preview" : "Sample data"
    }}</small>
  </div>
  <span class="undo-status" role="status" aria-live="polite">{{
    undoMessage
  }}</span>
  <p *ngIf="error" role="alert" class="error">{{ error }}</p>
  <div
    *ngIf="issues.length && issuesOpen"
    class="issues"
    aria-label="Page issues"
  >
    <button
      uiButton
      [wrap]="true"
      severity="danger"
      [text]="true"
      [outlined]="false"
      *ngFor="let issue of issues; trackBy: trackIssue"
      type="button"
      (click)="configure(issue.target)"
    >
      <strong>{{ issue.label }}</strong> — {{ issue.message }}
    </button>
  </div>
  <div
    *ngIf="mode === 'edit'"
    class="mobile-panel-switch"
    [hidden]="noticeSettingsOpen"
    role="group"
    aria-label="Staff page panels"
  >
    <button
      uiButton
      [text]="true"
      [outlined]="false"
      type="button"
      [attr.aria-pressed]="mobilePanel === 'page'"
      (click)="setMobilePanel('page')"
    >
      Page
    </button>
    <button
      uiButton
      [text]="true"
      [outlined]="false"
      type="button"
      [attr.aria-pressed]="mobilePanel === 'settings'"
      (click)="setMobilePanel('settings')"
    >
      Settings
    </button>
  </div>
  <div
    class="editor-body"
    [hidden]="noticeSettingsOpen"
    [attr.inert]="noticeSettingsOpen ? '' : null"
    [class.editor-body--try]="mode === 'try'"
    [class.editor-body--full]="mode === 'try' || !inspectorOpen"
    [class.editor-body--settings]="mobilePanel === 'settings'"
  >
    <div class="page-canvas" aria-label="Staff page canvas">
      <phms-workflow-presentation-preview
        [document]="document"
        [node]="node"
        [scope]="'detail'"
        [canvasSize]="canvasSize"
        (canvasWidthChange)="canvasWidth = $event"
        [componentCatalog]="componentCatalog"
        [detailAuthoring]="mode === 'edit'"
        [detailEditingDisabled]="disabled || loading"
        [detailSampleJourney]="mode === 'try'"
        [detailSelection]="selection"
        [detailFieldIssues]="fieldIssues"
        (detailConfigure)="configureFromCanvas($event, library.origin)"
        (detailFieldOrderChange)="reorderFields($event)"
        (detailBlockMove)="moveBlock($event)"
        (detailTabChange)="previewTabId = $event"
      />
    </div>
    <aside
      *ngIf="mode === 'edit' && inspectorOpen"
      #properties
      tabindex="-1"
      class="properties"
      aria-label="Page inspector"
    >
      <div
        class="selection-context"
        *ngIf="editingContext as context"
        role="group"
        aria-label="Editing context"
      >
        <div
          class="selection-context__parents"
          *ngIf="context.parents.length"
          role="group"
          aria-label="Parent elements"
        >
          <ng-container
            *ngFor="
              let parent of context.parents;
              let first = first;
              trackBy: trackSelection
            "
          >
            <span *ngIf="!first" aria-hidden="true">›</span>
            <button
              uiButton
              [wrap]="true"
              [text]="true"
              [outlined]="false"
              type="button"
              [attr.aria-label]="
                'Edit ' + parent.type.toLowerCase() + ': ' + parent.label
              "
              (click)="editParent(parent.target)"
            >
              {{ parent.label }}
            </button>
          </ng-container>
        </div>
        <span class="selection-context__type">{{ context.type }}</span>
        <strong class="selection-context__name" tabindex="-1">{{
          context.label
        }}</strong>
      </div>
      <label class="selection-picker"
        >Choose what to edit
        <select
          uiControl
          #pageElementPicker
          aria-label="Select page element"
          [ngModel]="selectionValue"
          (ngModelChange)="
            chooseSelectionFromControl($event, pageElementPicker)
          "
        >
          <optgroup
            *ngFor="let group of selectionGroups; trackBy: trackSelectionGroup"
            [label]="group.label"
          >
            <option
              *ngFor="let option of group.options; trackBy: trackSelection"
              [value]="targetValue(option.target)"
            >
              {{ option.label }}
            </option>
          </optgroup>
        </select>
      </label>
      <section *ngIf="selection?.kind === 'tabs' || selection?.kind === 'context'" class="page-settings" data-page-settings-inspector aria-label="Page settings">
        <p *ngIf="pageSettings.unavailableReason" role="status">{{ pageSettings.unavailableReason }}</p>
        <details *ngIf="pageSettings.unavailableReason" class="contract-details">
          <summary>Saved page settings</summary><pre>{{ node.declaration?.detail | json }}</pre>
        </details>
        <ng-container *ngIf="!pageSettings.unavailableReason">
        <section class="page-settings-section" aria-label="Reference content placement">
          <h5>Reference content placement</h5>
          <label>Placement<select uiControl #referencePlacementPicker #referencePlacementModel="ngModel"
            aria-label="Reference content placement" [disabled]="disabled || loading || !!pageSettings.unavailableReason"
            [ngModel]="detail.contextPlacement"
            (ngModelChange)="setContextFromControl($event, referencePlacementPicker, pageSettings.origin, referencePlacementModel)">
            <option value="side">Beside main content</option>
            <option value="below">Below main content</option>
            <option value="hidden" [disabled]="!!pageSettings.referencePlacementReason">Hidden</option>
          </select></label>
          <p>Reference content helps staff with the task. Actions and completion requirements stay in their fixed sidebar.</p>
          <p *ngIf="pageSettings.referencePlacementReason" role="status" data-reference-placement-reason>{{ pageSettings.referencePlacementReason }}</p>
          <ul *ngIf="pageSettings.blockingReferences.length" class="reference-content-blockers" data-reference-content-blockers aria-label="Reference content keeping the region visible">
            @for (reference of pageSettings.blockingReferences; track reference.instanceId + ':' + $index) {
              <li [attr.data-reference-block]="reference.instanceId">
                <strong>{{ reference.label }}</strong>
                <p *ngIf="reference.reason">{{ reference.reason }}</p>
                <button uiButton type="button" [disabled]="loading || !reference.available"
                  [attr.aria-label]="'Inspect reference content: ' + reference.label"
                  (click)="inspectReferenceContent(reference.instanceId, pageSettings.origin)">Inspect reference content</button>
              </li>
            }
          </ul>
          <button uiButton type="button" [disabled]="disabled || loading || !!pageSettings.unavailableReason || detail.contextPlacement === 'hidden'"
            (click)="showLibrary('supporting', undefined, library.origin)">Add reference content</button>
        </section>
        <section class="page-settings-section page-tabs-editor" aria-label="Page tabs settings">
        <h5>Page tabs</h5>
        <ng-container *ngIf="detail.tabs?.length; else singlePageTabs">
          <header class="page-tabs-toolbar">
            <small>{{ detail.tabs?.length }} / 8 tabs</small>
            <button uiButton type="button" [disabled]="disabled || loading || !!pageSettings.unavailableReason || (detail.tabs?.length || 0) >= 8" (click)="addTab(pageSettings.origin)"><i class="pi pi-plus" aria-hidden="true"></i> Add tab</button>
          </header>
          <table class="page-tabs-table" aria-label="Page tabs" aria-describedby="page-tabs-order-help">
            <thead><tr><th scope="col">Tab title</th><th scope="col" class="page-tabs-controls">Actions</th></tr></thead>
            <tbody>
              <tr *ngFor="let tab of detail.tabs; let index = index; trackBy: trackTab">
                <td><input uiControl #tabTitle [attr.aria-label]="'Tab title ' + (index + 1)" [value]="tab.label" maxlength="80" [disabled]="disabled || loading || !!pageSettings.unavailableReason" (change)="renameTab(tab.id, tabTitle, pageSettings.origin)" /></td>
                <td class="page-tabs-controls"><div class="page-tab-actions">
                  <button uiButton [text]="true" [outlined]="false" type="button" [attr.aria-label]="'Move ' + tab.label + ' tab up'" title="Move tab up" [disabled]="disabled || loading || !!pageSettings.unavailableReason || index === 0" (click)="moveTab(index, -1, pageSettings.origin, tab.id)"><i class="pi pi-arrow-up" aria-hidden="true"></i></button>
                  <button uiButton [text]="true" [outlined]="false" type="button" [attr.aria-label]="'Move ' + tab.label + ' tab down'" title="Move tab down" [disabled]="disabled || loading || !!pageSettings.unavailableReason || index === (detail.tabs?.length || 0) - 1" (click)="moveTab(index, 1, pageSettings.origin, tab.id)"><i class="pi pi-arrow-down" aria-hidden="true"></i></button>
                  <button uiButton [text]="true" [outlined]="false" type="button" [attr.aria-label]="'Remove ' + tab.label + ' tab'" title="Remove tab and move its content to the first remaining tab" [disabled]="disabled || loading || !!pageSettings.unavailableReason" (click)="removeTab(tab.id, pageSettings.origin)"><i class="pi pi-trash" aria-hidden="true"></i></button>
                </div></td>
              </tr>
            </tbody>
          </table>
          <small id="page-tabs-order-help">First tab opens by default.</small>
          <label>Task form tab<select uiControl #formTabModel="ngModel" aria-label="Task form tab" [ngModel]="detail.formTabId || detail.tabs?.[0]?.id" [disabled]="disabled || loading || !!pageSettings.unavailableReason" (ngModelChange)="setFormTab($event, pageSettings.origin, formTabModel)"><option *ngFor="let tab of detail.tabs; trackBy: trackTab" [value]="tab.id">{{tab.label}}</option></select></label>
          <details class="page-tabs-layout-options">
            <summary>Layout options</summary>
            <small>Removing a tab moves its content to the first remaining tab.</small>
            <button uiButton type="button" [disabled]="disabled || loading || !!pageSettings.unavailableReason" (click)="editTabs([], pageSettings.origin)">Use single page</button>
          </details>
        </ng-container>
        <ng-template #singlePageTabs>
          <p>Organize the main content into separate tabs.</p>
          <button uiButton type="button" [disabled]="disabled || loading || !!pageSettings.unavailableReason" (click)="enableTabs(pageSettings.origin)">Enable page tabs</button>
        </ng-template>
        </section>
        </ng-container>
      </section>
      <phms-workflow-step-components-editor
        *ngIf="
          !workEditorAvailable &&
          (selection?.kind === 'action' || selection?.kind === 'action-library')
        "
        [document]="document"
        [node]="node"
        scope="detail"
        [inspectorOnly]="true"
        [actionIdentity]="selectedActionIdentity"
        [componentCatalog]="componentCatalog"
        [componentCapabilities]="componentCapabilities"
        [disabled]="disabled || loading"
        (documentChange)="applyActionDocument($event)"
        (actionSelectionChange)="selectAction($event)"
        (openForm)="editActionForm($event)"
        (openOutcomes)="openOutcomes.emit($event)"
      />
      <button
        uiButton
        *ngIf="
          workEditorAvailable &&
          (selection?.kind === 'action' || selection?.kind === 'action-library')
        "
        type="button"
        [disabled]="disabled || loading"
        (click)="openActions.emit(selectedStaffAction)"
      >
        Edit actions in Work
      </button>
      <ng-container *ngIf="selectedCommand as command">
        <ng-container *ngIf="contract(command) as installed">
          <div *ngIf="selection?.kind === 'form'" class="form-layout">
            <label
              >Page layout<select
                uiControl
                #pageLayoutPicker
                aria-label="Page layout"
                [ngModel]="selectedInteractionIdentity"
                (ngModelChange)="
                  setInteractionFromControl($event, pageLayoutPicker)
                "
                [disabled]="disabled || loading"
              >
                <option value="">Default task form</option>
                <option
                  *ngIf="unavailableInteraction"
                  [value]="selectedInteractionIdentity"
                  disabled
                >
                  Saved form unavailable
                </option>
                <option
                  *ngFor="let command of commands"
                  [value]="commandIdentity(command)"
                >
                  {{ interactionLabel(commandIdentity(command)) }}
                </option>
              </select></label
            >
          </div>
          <label
            *ngIf="workEditorAvailable && quickRenameAvailable"
            class="quick-rename"
          >
            {{ quickRenameLabel }}
            <input
              uiControl
              [attr.aria-label]="quickRenameLabel"
              data-staff-page-text="rename"
              maxlength="120"
              [disabled]="disabled || loading"
              [ngModel]="quickRenameValue"
              (ngModelChange)="updateQuickRename($event)"
              (blur)="commitTextEdit()"
              (keydown)="onTextEditKeydown($event)"
              [attr.aria-invalid]="!!quickRenameError"
              [attr.aria-describedby]="
                quickRenameError ? 'staff-page-name-error' : null
              "
            />
            <small
              *ngIf="quickRenameError"
              id="staff-page-name-error"
              class="error"
              role="alert"
              >{{ quickRenameError }}</small
            >
          </label>
          <p *ngIf="formVersionUnavailable(command)" role="status">This saved form version is unavailable in this workflow format. Its settings are preserved.</p>
          <button
            uiButton
            *ngIf="workEditorAvailable"
            type="button"
            [disabled]="disabled || loading"
            (click)="openForm.emit(command)"
          >
            Edit form in Work
          </button>
          <ng-container *ngIf="!workEditorAvailable">
            <phms-workflow-capture-form-editor
              *ngIf="installed.supportsCaptureForm; else installedFields"
              [form]="command.captureForm ?? null"
              [copies]="captureFormCopies"
              [disabled]="disabled || loading || formVersionUnavailable(command)"
              [inspectorMode]="true"
              [showAddField]="false"
              [selectedFieldId]="selectedFieldId"
              (fieldSelectionChange)="selectField($event)"
              (formChange)="setCaptureForm(command, $event)"
            />
            <ng-template #installedFields>
              <p>
                The installed action defines this form's fields. Select a field
                to customize its supported settings.
              </p>
              <phms-workflow-form-fields-editor
                [command]="command"
                [installed]="installed"
                [disabled]="disabled || loading || formVersionUnavailable(command)"
                [inspectorMode]="true"
                [selectedFieldId]="selectedFieldId"
                (fieldSelectionChange)="selectField($event)"
                (configurationChange)="setFormConfiguration(command, $event)"
              />
            </ng-template>
          </ng-container>
          <div *ngIf="installed.supportsCaptureForm" class="form-insertion">
            <label>
              <span
                >Add a field to <strong>{{ selectedFormLabel }}</strong></span
              >
              <select
                uiControl
                aria-label="Add form field"
                #fieldType
                (change)="addField($any(fieldType.value)); fieldType.value = ''"
                [disabled]="disabled || loading || !canAddField"
              >
                <option value="" disabled selected>Choose a field type</option>
                <option *ngFor="let type of fieldTypes" [value]="type.code">
                  {{ type.label }}
                </option>
              </select>
            </label>
            <small *ngIf="formAtFieldLimit"
              >This form has reached its 50-field limit.</small
            >
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="selection?.kind === 'block'">
        <ng-container *ngIf="selected as block">
          <ng-container
            *ngIf="
              block.provider === 'notices' &&
                block.code === 'notices.delivery' &&
                block.version === 2 &&
                block.settingsVersion === 1;
              else genericContentProperties
            "
          >
            <ng-container *ngIf="noticeSettingsState as notice">
              <section
                class="notice-summary"
                data-notice-content-summary
                aria-label="Notice content settings summary"
              >
                <p *ngIf="notice.unavailableReason" role="status">
                  {{ notice.unavailableReason }}
                </p>
                <details
                  *ngIf="notice.unavailableReason"
                  class="contract-details notice-technical"
                  data-notice-original-settings
                >
                  <summary>Original saved settings</summary>
                  <pre>{{ notice.technical | json }}</pre>
                </details>
                <dl *ngIf="!notice.unavailableReason" class="notice-settings-facts">
                  <div>
                    <dt>Placement</dt>
                    <dd>
                      {{ regionLabel(block.region) }} ·
                      {{
                        block.width === "half"
                          ? "Half row"
                          : block.width === "full"
                            ? "Full row"
                            : block.width
                      }}
                    </dd>
                  </div>
                  <div>
                    <dt>Shared hearing source</dt>
                    <dd>{{ notice.sourceSummary }}</dd>
                  </div>
                  <div>
                    <dt>Notice work</dt>
                    <dd>{{ notice.workLabel }}</dd>
                  </div>
                  <div>
                    <dt>Shared policy</dt>
                    <dd>{{ notice.policySummary }}</dd>
                  </div>
                </dl>
                <p *ngIf="notice.workReason">{{ notice.workReason }}</p>
                <p *ngIf="notice.refusal" role="status">{{ notice.refusal.message }}</p>
                <div class="notice-settings-actions">
                  <label *ngIf="!pageSettings.unavailableReason && detail.tabs?.length"
                    >Tab<select
                      uiControl
                      #noticeBlockTabModel="ngModel"
                      aria-label="Block tab"
                      [ngModel]="block.tabId || detail.tabs?.[0]?.id"
                      [disabled]="
                        disabled ||
                        loading ||
                        mode !== 'edit' ||
                        !!notice.unavailableReason
                      "
                      (ngModelChange)="
                        setNoticeBlockTab($event, notice.origin, noticeBlockTabModel)
                      "
                    >
                      <option *ngFor="let tab of detail.tabs" [value]="tab.id">
                        {{ tab.label }}
                      </option>
                    </select></label
                  >
                  <button
                    uiButton
                    type="button"
                    aria-label="Move block up"
                    [disabled]="
                      disabled ||
                      loading ||
                      mode !== 'edit' ||
                      !!notice.unavailableReason ||
                      !canMove(-1)
                    "
                    (click)="moveNoticeBlock(-1, notice.origin)"
                  >
                    <i class="pi pi-arrow-up" aria-hidden="true"></i>
                  </button>
                  <button
                    uiButton
                    type="button"
                    aria-label="Move block down"
                    [disabled]="
                      disabled ||
                      loading ||
                      mode !== 'edit' ||
                      !!notice.unavailableReason ||
                      !canMove(1)
                    "
                    (click)="moveNoticeBlock(1, notice.origin)"
                  >
                    <i class="pi pi-arrow-down" aria-hidden="true"></i>
                  </button>
                </div>
                <button
                  uiButton
                  type="button"
                  data-open-notice-settings
                  [disabled]="loading"
                  (click)="openContentSettings(notice.origin)"
                >
                  Open content settings
                </button>
                <section
                  class="notice-completion-summary"
                  aria-label="Notice completion dependency"
                >
                  <h5>Completion requirement</h5>
                  <div
                    *ngFor="let requirement of notice.requirements"
                    class="notice-requirement"
                    [attr.data-notice-requirement]="requirement.id"
                  >
                    <strong>{{ requirement.label }}</strong>
                    <p *ngIf="requirement.reason">{{ requirement.reason }}</p>
                    <button
                      uiButton
                      [text]="true"
                      type="button"
                      [disabled]="loading || !requirement.available"
                      (click)="openNoticeRequirement(requirement.id, notice.origin)"
                    >
                      View in Work
                    </button>
                  </div>
                  <p *ngIf="!notice.requirements.length && !notice.unavailableReason">
                    No notice completion requirement is configured.
                  </p>
                </section>
                <button
                  uiButton
                  severity="danger"
                  type="button"
                  data-remove-notice-content
                  [disabled]="
                    disabled || loading || mode !== 'edit' || !!notice.unavailableReason
                  "
                  (click)="remove(notice.origin)"
                >
                  Remove content
                </button>
              </section>
            </ng-container>
          </ng-container>
          <ng-template #genericContentProperties>

          <header>
            <strong>{{ name(block) }}</strong>
            <button
              uiButton
              severity="danger"
              type="button"
              class="remove"
              [disabled]="disabled || loading"
              (click)="remove()"
            >
              Remove block
            </button>
          </header>
          <details class="contract-details">
            <summary>Saved block version</summary>
            <p>
              {{ block.provider }} · {{ block.code }} · Version
              {{ block.version }}
            </p>
          </details>
          <p
            class="block-deprecation"
            *ngIf="selectedManifest?.deprecated as explanation"
            role="note"
          >
            <strong>Deprecated version. </strong>{{ explanation }}
          </p>
          <div class="property-controls">
            <label *ngIf="detail.tabs?.length && block.region === 'main'">Tab<select uiControl aria-label="Block tab" [ngModel]="block.tabId || detail.tabs?.[0]?.id" [disabled]="disabled || loading" (ngModelChange)="setBlockTab($event)"><option *ngFor="let tab of detail.tabs" [value]="tab.id">{{tab.label}}</option></select></label>
            <label
              >Region<select
                uiControl
                #blockRegionPicker
                aria-label="Block region"
                [disabled]="disabled || loading || !selectedManifest"
                [ngModel]="block.region"
                (ngModelChange)="placeFromControl($event, blockRegionPicker)"
              >
                <option
                  *ngFor="let region of regions"
                  [value]="region"
                  [disabled]="!canPlace(block, region)"
                >
                  {{ regionLabel(region) }}
                </option>
              </select></label
            >
            <label
              >Width<select
                uiControl
                #blockWidthPicker
                aria-label="Block width"
                [attr.aria-describedby]="block.width === 'half' ? 'block-width-help' : null"
                [disabled]="disabled || loading || !blockWidthChoices.length"
                [ngModel]="block.width"
                (ngModelChange)="widthFromControl($event, blockWidthPicker)"
              >
                <option
                  *ngIf="!blockWidthChoices.includes(block.width)"
                  [value]="block.width"
                  disabled
                >
                  {{ block.width === "half" ? "Half row" : "Full row" }} (saved,
                  unavailable)
                </option>
                <option
                  *ngFor="let value of blockWidthChoices"
                  [value]="value"
                >
                  {{ value === "half" ? "Half row" : "Full row" }}
                </option>
              </select></label
            >
            @if (compactRecordGridUpgrade) {
              <button uiButton type="button" [disabled]="disabled || loading" (click)="upgradeRecordGrid()">
                Use compact record grid
              </button>
            }
            @if (schedulingBookingUpgrade) {
              <button uiButton type="button" [disabled]="disabled || loading" (click)="enableBookingOptions()">Enable staff-page booking options</button>
            }
            @if (combinedNoticeUpgrade) {
              <button uiButton type="button" [disabled]="disabled || loading" (click)="combineNoticeBlocks()">Combine recipients and delivery</button>
            }
            <button
              uiButton
              type="button"
              aria-label="Move block up"
              [disabled]="disabled || loading || !canMove(-1)"
              (click)="move(-1)"
            >
              <i class="pi pi-arrow-up" aria-hidden="true"></i>
            </button>
            <button
              uiButton
              type="button"
              aria-label="Move block down"
              [disabled]="disabled || loading || !canMove(1)"
              (click)="move(1)"
            >
              <i class="pi pi-arrow-down" aria-hidden="true"></i>
            </button>
          </div>
          <small *ngIf="block.width === 'half'" id="block-width-help">Half rows stack when page space is limited.</small>
          <div class="settings" *ngIf="selectedManifest; else unavailable">
            <phms-workflow-voting-configuration
              *ngIf="block.provider === 'voting'"
              [document]="document"
              [nodeId]="node.id"
              [code]="block.code"
              [editorKey]="block.instanceId"
              [capabilities]="componentCapabilities"
              [disabled]="disabled || loading"
              (documentChange)="applyVotingDocument($event)"
            />
            @if (selectedDomainBlock) {
              <p>
                All domain blocks on this step share one inmate/hearing source.
              </p>
              @if (domainGeneration === 1) {
                <p>
                  This step retains source contract 1. Upgrade the whole group
                  to use direct Inmate references or new history blocks.
                </p>
                <button
                  uiButton
                  type="button"
                  [disabled]="disabled || loading"
                  (click)="previewDomainUpgrade()"
                >
                  Review domain group upgrade
                </button>
              }
              @if (upgradePreview) {
                <div role="region" aria-label="Domain upgrade preview">
                  <p>
                    All domain blocks and reads will use source contract 2.
                    Source: {{ domainSource.bindingMode }}
                    {{ domainSource.referenceField || "" }}. Required SDMF:
                    {{ sdmfRequired ? "Yes" : "No" }}. Layout and placement are
                    preserved.
                  </p>
                  <button uiButton type="button" (click)="applyDomainUpgrade()">
                    Apply whole-group upgrade
                  </button>
                  <button
                    uiButton
                    type="button"
                    (click)="cancelDomainUpgrade()"
                  >
                    Cancel upgrade
                  </button>
                </div>
              }
              <label
                >Source<select
                  uiControl
                  [disabled]="disabled || loading"
                  [ngModel]="domainSource.bindingMode"
                  (ngModelChange)="setDomainSource($event)"
                >
                  <option value="linked-subject">
                    Linked hearing workflow
                  </option>
                  <option
                    value="process-reference"
                    [disabled]="!hearingReferenceFields.length"
                  >
                    Process record reference
                  </option>
                </select></label
              >
              @if (domainSource.bindingMode === "process-reference") {
                <label
                  >Record reference field<select
                    uiControl
                    [disabled]="disabled || loading"
                    [ngModel]="domainSource.referenceField"
                    (ngModelChange)="
                      setDomainSource('process-reference', $event)
                    "
                  >
                    @for (field of hearingReferenceFields; track field.key) {
                      <option [value]="field.key">
                        {{ field.label }} ({{
                          field.recordTypeCode === "incarcerated-person"
                            ? "Inmate"
                            : "Hearing"
                        }}
                        · {{ field.key }})
                      </option>
                    }
                  </select></label
                >
              }
              @if (selectedNoticeBlock) {
                <p>All notice blocks on this step share this policy.</p>
                <phms-notice-policy-editor
                  [value]="block.settings['policyJson']"
                  [disabled]="disabled || loading"
                  (valueChange)="setNoticePolicy($event)"
                />
                <p>
                  {{
                    noticeActionsEnabled
                      ? "Notice work prepares copies and records manual notice evidence. It does not send messages or complete the step. Add a Hearing notices requirement in Work to require notices or responses."
                      : "This notice workspace is read-only. Enable notice work to record manual notice evidence. Add a Hearing notices requirement in Work to require notices or responses."
                  }}
                </p>
                @if (!noticeActionsEnabled) {
                  <button
                    uiButton
                    type="button"
                    [disabled]="disabled || loading"
                    (click)="enableNoticeActions()"
                  >
                    Enable notice work
                  </button>
                } @else {
                  <button
                    uiButton
                    type="button"
                    [disabled]="disabled || loading"
                    (click)="disableNoticeActions()"
                  >
                    Make notice work read-only
                  </button>
                }
              }
              @if (block.code === "sdmf.analysis") {
                <label class="check"
                  ><input
                    uiControl
                    type="checkbox"
                    [disabled]="disabled || loading"
                    [ngModel]="sdmfRequired"
                    (ngModelChange)="setSdmfRequired($event)"
                  />Require completed SDMF before completing this step</label
                >
                <p>
                  Requires all 13 rated factors, a summary narrative and
                  explicit certification or confirmation for each visit.
                </p>
              }
            }
            @if (
              block.provider === "hearing" && block.code === "hearing.decision"
            ) {
              <label
                >Quorum evaluation step<select
                  uiControl
                  [disabled]="disabled || loading"
                  [ngModel]="block.settings['quorumNodeId']"
                  (ngModelChange)="setting('quorumNodeId', $event)"
                >
                  <option value="">Select a quorum step</option>
                  <option
                    *ngFor="let source of hearingSourceNodes('voting.result')"
                    [value]="source.id"
                  >
                    {{ source.displayName || source.stepCode }}
                  </option>
                </select></label
              >
              <label
                >SDMF preparation step<select
                  uiControl
                  [disabled]="disabled || loading"
                  [ngModel]="block.settings['sdmfNodeId']"
                  (ngModelChange)="setting('sdmfNodeId', $event)"
                >
                  <option value="">Select a preparation step</option>
                  <option
                    *ngFor="let source of hearingSourceNodes('sdmf.analysis')"
                    [value]="source.id"
                  >
                    {{ source.displayName || source.stepCode }}
                  </option>
                </select></label
              >
              <p>
                The final decision retains this hearing's evaluated round and
                certified preparation SDMF. Require Conduct hearing completion
                when votes and the decision are recorded on this step.
              </p>
            }
            @if (block.provider === 'hearing' && block.code === 'hearing.grant-review') {
              <label>Hearing decision step<select uiControl [disabled]="disabled || loading"
                [ngModel]="block.settings['sourceNodeId']" (ngModelChange)="setting('sourceNodeId', $event)">
                <option value="">Select Conduct hearing</option>
                <option *ngFor="let source of hearingSourceNodes('hearing.decision')" [value]="source.id">{{source.displayName || source.stepCode}}</option>
              </select></label>
            }
            @if (block.provider === 'scheduling' && block.code === 'scheduling.hearing' && block.version === 3) {
              <label>Booking mode<select uiControl aria-label="Booking mode" [disabled]="disabled || loading" [ngModel]="block.settings['bookingMode']" (ngModelChange)="setting('bookingMode', $event)">
                <option value="calendar">Open scheduling calendar</option><option value="inline-date">Choose date on staff page</option>
              </select></label>
              @if (block.settings['bookingMode'] === 'inline-date') {
                <label>Default start time<input uiControl aria-label="Default start time" type="time" [disabled]="disabled || loading" [ngModel]="block.settings['startTime']" (ngModelChange)="setting('startTime', $event)" /></label>
                <label>Default end time<input uiControl aria-label="Default end time" type="time" [disabled]="disabled || loading" [ngModel]="block.settings['endTime']" (ngModelChange)="setting('endTime', $event)" /></label>
                <label>Booking time zone<input uiControl aria-label="Booking time zone" [disabled]="disabled || loading" placeholder="America/Los_Angeles" [ngModel]="block.settings['timeZoneId']" (ngModelChange)="setting('timeZoneId', $event)" /></label>
                <label>Default hearing location<input uiControl aria-label="Default hearing location" maxlength="200" [disabled]="disabled || loading" [ngModel]="block.settings['locationName']" (ngModelChange)="setting('locationName', $event)" /></label>
                <label>Default hearing room<input uiControl aria-label="Default hearing room" maxlength="200" [disabled]="disabled || loading" [ngModel]="block.settings['roomName']" (ngModelChange)="setting('roomName', $event)" /></label>
              }
            }
            <ng-container
              *ngFor="
                let field of block.provider === 'voting' ||
                block.provider === 'hearing' || (block.provider === 'scheduling' && block.version === 3)
                  ? []
                  : fields;
                trackBy: trackField
              "
            >
              <label *ngIf="field.schema.type === 'string'" class="text-setting"
                >{{ fieldLabel(field.name)
                }}<textarea
                  uiControl
                  rows="2"
                  data-staff-page-text="block"
                  [attr.data-staff-page-setting]="field.name"
                  [attr.aria-label]="fieldLabel(field.name)"
                  [maxlength]="field.schema.maxLength"
                  [disabled]="disabled || loading"
                  [ngModel]="blockSettingValue(field.name)"
                  (ngModelChange)="updateBlockText(field.name, $event)"
                  (blur)="commitTextEdit()"
                  (keydown)="onTextEditKeydown($event, true)"
                  [attr.aria-invalid]="!!blockTextError(field.name)"
                  [attr.aria-describedby]="
                    blockTextError(field.name)
                      ? 'staff-page-text-error-' + field.name
                      : null
                  "
                ></textarea>
                <small
                  *ngIf="blockTextError(field.name)"
                  [id]="'staff-page-text-error-' + field.name"
                  class="error"
                  role="alert"
                  >{{ blockTextError(field.name) }}</small
                >
              </label>
              <label *ngIf="field.schema.type === 'boolean'" class="check"
                ><input
                  uiControl
                  type="checkbox"
                  [disabled]="disabled || loading"
                  [ngModel]="block.settings[field.name]"
                  (ngModelChange)="setting(field.name, $event)"
                />{{ fieldLabel(field.name) }}</label
              >
              <label *ngIf="field.schema.type === 'enum'"
                >{{ fieldLabel(field.name)
                }}<select
                  uiControl
                  [disabled]="disabled || loading"
                  [ngModel]="block.settings[field.name]"
                  (ngModelChange)="setting(field.name, $event)"
                >
                  <option
                    *ngFor="let value of field.schema.values"
                    [value]="value"
                  >
                    {{ value }}
                  </option>
                </select></label
              >
              <label *ngIf="field.schema.type === 'integer'"
                >{{ fieldLabel(field.name)
                }}<input
                  uiControl
                  type="number"
                  [min]="field.schema.minimum"
                  [max]="field.schema.maximum"
                  [disabled]="disabled || loading"
                  [ngModel]="block.settings[field.name]"
                  (ngModelChange)="setting(field.name, $event)"
              /></label>
            </ng-container>
          </div>
          <ng-template #unavailable
            ><p>
              Its saved configuration is preserved. This exact block version
              must be installed before editing.
            </p></ng-template
          >
          </ng-template>
        </ng-container>
      </ng-container>
    </aside>
  </div>
  <ng-container *ngIf="noticeSettingsOpen">
    <section
      *ngIf="noticeSettingsState as notice"
      class="notice-settings"
      data-notice-settings-task
      aria-labelledby="notice-settings-title"
    >
      <header class="notice-settings-header">
        <button
          uiButton
          [text]="true"
          type="button"
          data-back-to-notice-canvas
          [disabled]="loading"
          (click)="backToContentCanvas(notice.origin)"
        >
          <i class="pi pi-arrow-left" aria-hidden="true"></i> Back to canvas
        </button>
        <h3 id="notice-settings-title" data-notice-settings-heading tabindex="-1">
          {{ notice.name }}
        </h3>
        <p>
          Shared source, policy and completion dependencies for this step's notice
          content.
        </p>
      </header>
      <div class="notice-settings-body">
        <p
          *ngIf="notice.unavailableReason"
          role="status"
          data-notice-settings-unavailable
        >
          {{ notice.unavailableReason }}
        </p>
        <p *ngIf="notice.refusal" role="status" data-notice-refusal>
          {{ notice.refusal.message }}
        </p>
        <section
          *ngIf="!notice.unavailableReason"
          class="notice-settings-group"
          aria-label="Notice placement"
        >
          <h4>Placement</h4>
          <p *ngIf="selected as block">
            {{ regionLabel(block.region) }} ·
            {{
              block.width === "half"
                ? "Half row"
                : block.width === "full"
                  ? "Full row"
                  : block.width
            }}
          </p>
          <p *ngIf="detail.tabs?.length">
            The content stays on its saved page tab. Use the canvas inspector to
            change its position or tab.
          </p>
        </section>
        <section
          class="notice-settings-group"
          aria-label="Shared hearing source"
          data-notice-source-settings
        >
          <h4>Shared hearing source</h4>
          <p>{{ notice.sourceSummary }}</p>
          <details>
            <summary>Source settings</summary>
            <p>All domain content on this step uses the same hearing source.</p>
            <label
              >Source<select
                uiControl
                #noticeSourceModel="ngModel"
                aria-label="Notice hearing source"
                [disabled]="
                  disabled ||
                  loading ||
                  !!notice.unavailableReason ||
                  !notice.sourceChoices.length
                "
                [ngModel]="notice.sourceValue"
                (ngModelChange)="
                  setNoticeSource($event, notice.origin, noticeSourceModel)
                "
              >
                @for (source of notice.sourceChoices; track source.value) {
                  <option [value]="source.value">{{ source.label }}</option>
                }
              </select></label
            >
          </details>
        </section>
        <section
          class="notice-settings-group"
          aria-label="Configured notice work"
        >
          <h4>Notice work · {{ notice.workLabel }}</h4>
          <p *ngIf="notice.workReason">{{ notice.workReason }}</p>
          <p>
            Notice work prepares copies and records manual notice evidence. It
            does not send messages or complete the step.
          </p>
          <div class="notice-settings-actions">
            <button
              uiButton
              type="button"
              data-enable-notice-work
              [disabled]="
                disabled || loading || mode !== 'edit' || !notice.canEnableWork
              "
              (click)="enableNoticeActions(notice.origin)"
            >
              Enable notice work
            </button>
            <button
              uiButton
              type="button"
              data-read-only-notice-work
              [disabled]="
                disabled || loading || mode !== 'edit' || !notice.canMakeReadOnly
              "
              (click)="disableNoticeActions(notice.origin)"
            >
              Make notice work read-only
            </button>
          </div>
        </section>
        <section
          class="notice-settings-group"
          aria-label="Shared notice policy"
          data-notice-policy-settings
        >
          <h4>Shared notice policy</h4>
          <p>{{ notice.policySummary }}</p>
          <p>
            Changes apply to all notice content on this step and its existing
            notice completion requirement.
          </p>
          <phms-notice-policy-editor
            [value]="notice.policyJson"
            [disabled]="
              disabled || loading || mode !== 'edit' || !!notice.unavailableReason
            "
            [changeContext]="noticePolicyContext()"
            [currentChangeContext]="noticePolicyContext"
            [currentValue]="currentNoticePolicy"
            (policyChangeRequested)="setNoticePolicyRequest($event)"
          />
        </section>
        <section
          class="notice-settings-group notice-completion-summary"
          aria-label="Notice completion dependency"
          data-notice-completion-settings
        >
          <h4>Completion requirement</h4>
          <div
            *ngFor="let requirement of notice.requirements"
            class="notice-requirement"
            [attr.data-notice-requirement]="requirement.id"
          >
            <strong>{{ requirement.label }}</strong>
            <p *ngIf="requirement.reason">{{ requirement.reason }}</p>
            <button
              uiButton
              [text]="true"
              type="button"
              [disabled]="loading || !requirement.available"
              (click)="openNoticeRequirement(requirement.id, notice.origin)"
            >
              View in Work
            </button>
          </div>
          <p *ngIf="!notice.requirements.length && !notice.unavailableReason">
            No notice completion requirement is configured.
          </p>
          <p>
            The task form and its completion requirement stay separate. Manage
            completion requirements in Work.
          </p>
        </section>
        <details
          class="notice-settings-group notice-technical"
          data-notice-technical
        >
          <summary>Version and dependencies</summary>
          <pre>{{ notice.technical | json }}</pre>
        </details>
        <button
          uiButton
          severity="danger"
          type="button"
          data-remove-notice-content
          [disabled]="
            disabled || loading || mode !== 'edit' || !!notice.unavailableReason
          "
          (click)="remove(notice.origin)"
        >
          Remove content
        </button>
      </div>
    </section>
  </ng-container>
  <ng-template #contentLibraryStatus>
    <div class="content-library-status" data-staff-content-library-status>
      <button
        *ngIf="unavailableCount"
        uiButton
        [text]="true"
        type="button"
        [attr.aria-expanded]="showUnavailable"
        (click)="toggleContentLibraryUnavailable()"
      >
        {{ showUnavailable ? "Hide unavailable content" : "Show unavailable content" }}
        ({{ unavailableCount }})
      </button>
      <p *ngIf="showUnavailable">
        These choices cannot be added here. Saved content keeps its exact version.
      </p>
    </div>
  </ng-template>
  <ng-template #contentLibraryEntryDetails let-entry>
    <ng-container *ngIf="contentLibraryDetails(entry) as item">
      <p class="content-library-facts" data-staff-content-facts>
        {{ item.instances === "repeatable" ? "Repeatable" : "One per workspace" }}
        ·
        {{ item.layout.widths.includes("half") && item.layout.widths.includes("full")
          ? "Full or half row"
          : item.layout.widths.includes("half") ? "Half row" : "Full row" }}
      </p>
      <details class="contract-details content-library-version" data-staff-content-version>
        <summary>Version details</summary>
        <dl>
          <div><dt>Content</dt><dd>{{ item.provider }} · {{ item.code }} · Version {{ item.version }}</dd></div>
          <div><dt>Settings contract</dt><dd>{{ item.settingsSchema.code }} · Version {{ item.settingsSchema.version }}</dd></div>
        </dl>
      </details>
    </ng-container>
  </ng-template>
  <phms-workflow-library-selector
    #contentLibrary
    [title]="'Add to ' + regionLabel(target)"
    searchLabel="Search page content"
    allCategoryLabel="All categories"
    [categories]="contentLibraryCategories"
    [entries]="contentLibraryEntries"
    [open]="libraryOpen"
    [active]="contentLibraryActive"
    [context]="contentLibraryContext"
    [disabled]="disabled || loading"
    [loading]="catalogLoading || loading"
    [loadingMessage]="loading ? 'Adding content…' : 'Checking available content…'"
    [error]="catalogError"
    retryLabel="Retry available content"
    [statusTemplate]="contentLibraryStatus"
    [entryDetailsTemplate]="contentLibraryEntryDetails"
    emptyMessage="No available content matches this region."
    noResultsMessage="No content matches your search and category."
    (opened)="contentLibraryOpened()"
    (chooseRequested)="chooseContentLibrary($event)"
    (retryRequested)="retryContentLibrary()"
    (closing)="contentLibraryClosing($event)"
    (closed)="contentLibraryClosed($event)"
  />
  </ng-container>
  </ng-container>
</section>
